import React from "react";

const ChillerTruckWhenToUse = ({ title, paragraphs, image, imageAlt }) => {
  return (
    <section className="container-fluid py-5 overflow-hidden ct-when-section">
      <div className="container py-5">
        <div className="row align-items-stretch">

          {/* Content */}
          <div
            className="col-md-6 d-flex flex-column justify-content-center"
            data-aos="fade-right"
            data-aos-duration="1200"
            data-aos-once="true"
          >
            <h2 className="h2-title mb-4">{title}</h2>
            {paragraphs.map((p, i) => (
              <p key={i} className="ct-when-para">{p}</p>
            ))}
            <div className="d-flex flex-wrap gap-3 mt-3">
              <a href="tel:+971544792905" className="mini-btn primary">Call Now</a>
              <a
                href="https://wa.me/971544792905"
                target="_blank"
                rel="noopener noreferrer"
                className="mini-btn secondary-dark"
              >
                WhatsApp Now
              </a>
            </div>
          </div>

          {/* Image */}
          <div
            className="col-md-6 mt-4 mt-md-0"
            data-aos="fade-left"
            data-aos-duration="1200"
            data-aos-once="true"
          >
            <div className="about-image-wrapper">
              <img
                src={image}
                alt={imageAlt}
                className="about-image"
                loading="lazy"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ChillerTruckWhenToUse;
